import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { PersistState } from '~/types/common'

type AuthState = {
  accessToken: string
  refreshToken: string
  setTokens: (accessToken: string, refreshToken: string) => void
  clearTokens: () => void
  resetState: () => void
}

const initialState = {
  accessToken: '',
  refreshToken: '',
}

export const useAuthStore = create<AuthState>(
  (persist as unknown as PersistState<AuthState>)(
    (set) => ({
      ...initialState,
      setTokens: (accessToken: string, refreshToken: string) => set({ accessToken, refreshToken }),
      clearTokens: () => set({ accessToken: '', refreshToken: '' }),
      resetState: () => set(initialState),
    }),
    {
      name: 'herodx-admin-auth',
    },
  ),
)
